// src/context/SocketContext.js
import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import io from 'socket.io-client';
import { useDispatch, useSelector } from 'react-redux';
import {
  ReceiveSupportMessage,
  TypingSupport,
  StopTypingSupport,
  MessageReadSupport,
  LoadSupportConversation,
} from '../redux/chatSlice';
import Cookies from "js-cookie";
import beepSound from "../assets/notification.mp3";

const SocketContext = createContext();

export const useSocket = () => {
  return useContext(SocketContext);
};

export const SocketProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { isAuthenticated, } = useSelector((state) => state.user);
  const token = Cookies.get("accessToken");
  const [socket, setSocket] = useState(null);
  const beepAudio = useRef(new Audio(beepSound));

  useEffect(() => {
    let socketInstance;

    if (isAuthenticated && token) { // Ensure token exists
      // Initialize Socket.io client
      socketInstance = io("https://cashback-479780104538.europe-west2.run.app", { // Replace with your backend URL
        auth: {
          token, // Send token in auth
        },
      });

      setSocket(socketInstance);

      // Listen for connection events
      socketInstance.on('connect', () => {
        console.log('Connected to Socket.io server');
      });

      socketInstance.on('disconnect', () => {
        console.log('Disconnected from Socket.io server');
      });

      // Listen for support messages
      socketInstance.on('support:receive_message', (message) => {
        dispatch(ReceiveSupportMessage(message));
        beepAudio.current.play().catch((error) => {
          console.error("Error playing beep sound:", error);
        });
      });

      // Listen for conversation assignment
      socketInstance.on('conversation_assigned', ({ conversationId, userId }) => {
        console.log('Assigned conversation:', conversationId);
        dispatch(LoadSupportConversation(conversationId));
      });

      // Listen for typing indicators
      socketInstance.on('support:typing', ({ conversationId, isTyping, from }) => {
        dispatch(TypingSupport({ from }));
      });

      socketInstance.on('support:stop_typing', ({ conversationId, from }) => {
        dispatch(StopTypingSupport({ from }));
      });

      // Listen for message read receipts
      socketInstance.on('support:message_read', ({ messageId }) => {
        dispatch(MessageReadSupport(messageId));
      });

      // Optionally handle authentication errors
      socketInstance.on('connect_error', (err) => {
        console.error('Connection Error:', err.message);
      });
    }

    return () => {
      if (socketInstance) {
        socketInstance.disconnect();
      }
    };
  }, [isAuthenticated, dispatch, token]);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
};
